<template>
  <v-container fluid>
    <v-dialog v-model="addDocumentDialog" >
      <v-card>
        <v-container  fluid grid-list-lg class="mx-0 pa-0" style="overflow: hidden !important;">
          <v-layout class="" row wrap>
            <v-flex xs12>
              <type-ahead @selected="addFeaturedArticle" selecting="true"></type-ahead>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card class="grey lighten-4 elevation-0">
        <v-card-title style="background: #e3f2fd; text-transform: capitalize;" class="title">
          {{title}}
          <v-spacer></v-spacer>
          <!--<v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>-->

          &nbsp;
          <v-btn fab small class="blue" @click.native="addFile()">
            <v-icon color="white">attachment</v-icon>
          </v-btn>


          <v-btn :disabled="!saveEnabled" fab small class="green darken-2" @click.native="save()">
            <v-icon color="white">save</v-icon>
          </v-btn>

          <v-btn fab small class="grey" @click.native="cancel()">
            <v-icon>cancel</v-icon>
          </v-btn>
          &nbsp;
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md >
            <v-layout row wrap v-if="this.document.docType==='policy'">
              <v-flex md12 xs12>
                <v-text-field name="title" label="Policy Title" hint="Policy Title is required" value="Input text" v-model="document.title"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <v-flex md12 xs12>
                <v-textarea single-line name="purpose" label="Purpose" hint="Policy Purpose is required" v-model="document.purpose"
                              class="v-input--is-focused blue--text" required></v-textarea>
              </v-flex>

              <v-flex xs12>
                <v-divider></v-divider>
                <br/>
              </v-flex>

              <v-flex  xs10 >
                <froala :tag="'textarea'" :config="config" v-model="document.body">
                </froala>
              </v-flex>

              <v-flex xs2>
              <v-flex>
                <v-text-field name="number" label="Policy Number" hint="Policy Number is required" value="Input text" v-model="document.num"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field name="series" label="Policy Series" hint="Policy Series is required" value="Input text" v-model="document.series"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-select required v-bind:items="policyTypes" label="Type" item-text="title" item-value="id" v-model="document.type"></v-select>
              </v-flex>
              <v-flex>
                <v-checkbox  v-model="document.annualreview" label="Annual Review" ></v-checkbox >
              </v-flex>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="this.document.docType==='school law' || this.document.docType === 'servicemanual'">


                <v-flex md9 xs12>
                    <v-text-field  name="revisorURL" label="Revisor URL" hint="Revisor URL is required"
                                   v-model="document.revisorurl"
                                   class="v-input--is-focused blue--text" required></v-text-field>
                </v-flex>

                <v-flex md3 xs12>
                    <v-text-field name="number" label="Revisor Number" hint="Revisor Number is required" value="Input text" v-model="document.revnumber"
                                  class="v-input--is-focused blue--text" required></v-text-field>
                </v-flex>

              <v-flex md12 xs12>
                <v-textarea single-line name="search cotnent" label="Revisor Text" v-model="document.searchcontent"
                            class="v-input--is-focused blue--text" disabled></v-textarea>
              </v-flex>

              <v-flex md12 xs12>
                <v-text-field name="description" label="Description" hint="Description is required"
                              value="Input text" v-model="document.description"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field  name="keywords" label="Keywords" hint="Keywords are optional"
                               v-model="document.keywords"
                            class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>



              <v-flex xs12>
                <v-divider></v-divider>
                <br/>
              </v-flex>

              <v-flex md8 xs12>
                <v-text-field  name="citation" label="MSBA Citation" hint="Citation is required"
                               v-model="document.citation"
                               class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <!--
              <v-flex md5 xs12>
                <v-text-field  name="chapter" label="Chapter" hint="Chapter is required"
                               v-model="document.chapter"
                               class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

                <v-flex md3 xs12>
                    <v-text-field name="number" label="Section" hint="Revisor section is required" value="Input text" v-model="document.section"
                                  class="v-input--is-focused blue--text" required></v-text-field>
                </v-flex>
              -->

                <v-flex md4 xs12>
                  <v-select required v-bind:items="schoolLawTypes" label="Type" item-text="title" item-value="id" v-model="document.revtype"></v-select>
                </v-flex>

            </v-layout>


            <v-layout row wrap v-if="this.document.docType==='publication'">
              <v-flex md12 xs12>
                <v-text-field name="title" label="Publication Title" hint="Publication Title is required"
                              value="Input text" v-model="document.title"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <v-flex md12 xs12>
                <v-text-field name="keywords" label="Keywords" hint="Keywords is optional"
                              v-model="document.keywords"
                            class="v-input--is-focused blue--text" ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-divider></v-divider>
                <br/>
              </v-flex>

              <v-flex  xs10 >
                <froala :tag="'textarea'" :config="config" v-model="document.body">
                </froala>
              </v-flex>

              <v-flex xs2>
                <v-flex>
                  <v-dialog
                    ref="dialogDate"
                    v-model="modalDate"
                    :return-value.sync="document.dateof"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :value="formatDate(document.dateof)"
                      label="Publication Date"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="document.dateof" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogDate.save(document.dateof);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex>
                  <v-select required v-bind:items="publicationTypes" label="Type" item-text="title" item-value="id" v-model="document.type"></v-select>
                </v-flex>
                <v-flex>
                  <v-text-field name="author" label="Author"
                                v-model="document.author"
                                class="v-input--is-focused blue--text" ></v-text-field>
                  </v-flex>
              </v-flex>
            </v-layout>


            <v-layout row wrap v-if="this.document.docType==='resource'">
              <v-flex md12 xs12>
                <v-text-field name="title" label="Resource Title" hint="Resource Title is required"
                              value="Input text" v-model="document.title"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <v-flex md12 xs12>
                <v-text-field name="keywords" label="Keywords" hint="Keywords is optional"
                              v-model="document.keywords"
                              class="v-input--is-focused blue--text" ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-divider></v-divider>
                <br/>
              </v-flex>

              <v-flex  xs10 >
                <froala :tag="'textarea'" :config="config" v-model="document.body">
                </froala>
              </v-flex>

              <v-flex xs2>
                <v-flex>
                  <v-dialog
                      ref="dialogDate"
                      v-model="modalDate"
                      :return-value.sync="document.dateof"
                      persistent
                      lazy
                      full-width
                      width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        :value="formatDate(document.dateof)"
                        label="Publication Date"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker
                        v-model="document.dateof" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogDate.save(document.dateof);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex>
                  <v-select required v-bind:items="resourceTypes" label="Type" item-text="title" item-value="id" v-model="document.type"></v-select>
                </v-flex>
                <v-flex>
                  <v-text-field name="author" label="Author"
                                v-model="document.author"
                                class="v-input--is-focused blue--text" ></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="this.document.docType==='leaderarchive'">
             <v-flex xs10>

                <v-flex xs12 v-if="document.featuredArticles != null">
                  <v-card v-for="featuredArticle in getFeaturedArticles(document.featuredArticles)">
                    <v-layout row wrap align-center>
                      <v-flex xs1>
                        <v-btn icon ripple  small @click="removeFeaturedArticle(featuredArticle)">
                          <v-icon color="red lighten-1">delete</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs9>
                        {{featuredArticle.title}}
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 text-xs-center>
                  <v-btn @click="addDocumentDialog=true" >
                    Add Featured Article
                  </v-btn>
                </v-flex>

              </v-flex>
              <v-flex xs2>
                <v-flex>
                  <v-dialog
                      ref="dialogDate"
                      v-model="modalDate"
                      :return-value.sync="document.publicationDate"
                      persistent
                      lazy
                      full-width
                      width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        :value="formatDate(document.publicationDate)"
                        label="Publication Date"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker
                        v-model="document.publicationDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogDate.save(document.publicationDate);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-flex>


            </v-layout>
            <v-layout row wrap v-if="this.document.docType==='journalarchive'">
              <v-flex xs10>
                <v-text-field name="title" label="Issuu Link" hint="Issuu Link required"
                              value="Input text" v-model="document.issuuLink"
                              class="v-input--is-focused blue--text" disabled></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-flex>
                  <v-dialog
                      ref="dialogDate"
                      v-model="modalDate"
                      :return-value.sync="document.publicationDate"
                      persistent
                      lazy
                      full-width
                      width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        :value="formatDate(document.publicationDate)"
                        label="Publication Date"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker
                        v-model="document.publicationDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogDate.save(document.publicationDate);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-flex>

              <v-flex xs12 v-if="document.featuredArticles != null">
                <v-card v-for="featuredArticle in getFeaturedArticles(document.featuredArticles)" >
                  <v-layout row wrap align-center>
                    <v-flex xs1>
                      <v-btn icon ripple  small @click="removeFeaturedArticle(featuredArticle)">
                        <v-icon color="red lighten-1">delete</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs9>
                      {{featuredArticle.title}}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 text-xs-center>
                <v-btn @click="addDocumentDialog=true" >
                  Add Featured Article
                </v-btn>
              </v-flex>


            </v-layout>
            <v-layout row wrap v-if="this.document.docType==='weeklyadvocatearchive'">
              <v-flex xs10>
                <v-text-field name="linkText" label="Link Text" hint="Link text required"
                              value="Input text" v-model="document.linkText"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-flex>
                  <v-dialog
                      ref="dialogDate"
                      v-model="modalDate"
                      :return-value.sync="document.publicationDate"
                      persistent
                      lazy
                      full-width
                      width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        :value="formatDate(document.publicationDate)"
                        label="Publication Date"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker
                        v-model="document.publicationDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogDate.save(document.publicationDate);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-flex>

              <v-flex xs12>
                <v-text-field name="linkURL" label="Link URL" hint="Link text required"
                              value="Input text" v-model="document.linkURL"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

            </v-layout>


            <v-layout row wrap v-if="this.document.docType==='eclippingsarchive'">
              <v-flex xs10>
                <v-text-field name="linkText" label="Link Text" hint="Link text required"
                              value="Input text" v-model="document.linkText"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-flex>
                  <v-dialog
                      ref="dialogDate"
                      v-model="modalDate"
                      :return-value.sync="document.publicationDate"
                      persistent
                      lazy
                      full-width
                      width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        :value="formatDate(document.publicationDate)"
                        label="Publication Date"
                        prepend-icon="event"
                        readonly
                    ></v-text-field>
                    <v-date-picker
                        v-model="document.publicationDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogDate.save(document.publicationDate);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-flex>

              <v-flex xs12>
                <v-text-field name="linkURL" label="Link URL" hint="Link text required"
                              value="Input text" v-model="document.linkURL"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <v-flex xs8>
                <v-text-field name="sourceName" label="Source Name" hint="Source name required"
                              value="Input text" v-model="document.sourceName"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>

              <v-flex xs4>
                <v-checkbox  v-model="document.paywalled" label="Behind paywall (subscription/signin)" ></v-checkbox >
              </v-flex>

              <v-flex xs12 v-show="document.paywalled">
                <v-textarea single-line name="excerpt" label="Excerpt"  v-model="document.excerpt"
                            class="v-input--is-focused blue--text" ></v-textarea>
              </v-flex>


            </v-layout>

            <v-layout row wrap v-if="this.document.docType==='resource' || this.document.docType==='publication' || this.document.docType==='policy' || this.document.docType==='servicemanual' || this.document.docType==='school law' ">
              <v-flex xs2>
                <v-checkbox  v-model="document.publicvisible" label="Public Doc" ></v-checkbox >
              </v-flex>
                <v-flex xs3>
                  <v-select required v-bind:items="$resourceLibrary.schema.categories" @input="document.websubcat=null;" label="Library Category"  item-text="label" item-value="id" v-model="document.webcat"></v-select>
                </v-flex>
              <v-flex xs2>
                  <v-btn small @click="document.websubcat=null; document.webcat=null;" >
                    Clear
                  </v-btn>
                </v-flex>
                <v-flex xs3>
                  <v-select required v-bind:items="availableSubcats" label="Sub Category" clearable="true" item-text="label" item-value="id" v-model="document.websubcat"></v-select>
                </v-flex>


            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 v-if="attachedFiles && attachedFiles.length>0">

                <v-list class="transparent elevation-0" two-line >
                  <v-list-tile avatar ripple v-for="(item, index) in attachedFiles"
                               v-if="item !== null && item !== undefined" v-bind:key="index" class="grey lighten-2 mt-2 mb-2 " >
                    <v-list-tile-content dark >
                      <v-list-tile-title class="heading blue--text"><a :href="item.link">{{ item.name }}</a>

                      </v-list-tile-title>
                      <v-list-tile-sub-title class="grey--text text--darken-4">{{ item.fileName}}</v-list-tile-sub-title>
                      <!--<v-list-tile-sub-title>{{ item.unitInStock }}
                        </v-list-tile-sub-title>-->
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn fab small class="navy" @click.native="removeFile(item)">
                        <v-icon v-bind:class="[item.active ? 'teal--text': 'grey--text']">delete</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-layout row justify-center>
      <v-dialog v-model="addFileModal" width="700" persistent>
        <v-card>
          <v-tabs
              v-model="addAttachType"
              color="cyan"
              dark
              centered
              slider-color="yellow"
          >
            <v-tab key="0" ripple>
              <v-card-title class="cyan black--text">Add Attachment</v-card-title></v-tab>
            <v-tab key="1" ripple>
              <v-card-title class="cyan black--text">Add Link</v-card-title></v-tab>
            <v-tab-item key="0" >
              <v-card-text>
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field label="Attachment Name" class="input-group--focused" required hint="Attachment Name is required" v-model="attachmentName" ></v-text-field>
                    </v-flex>
                    <v-flex xs12  v-show="fileUploadProgress == null">
                      <fileupload v-on:error="errorUpload" v-on:start="startUpload" v-on:finish="finishUpload" v-on:progress="progress" :target="fileUploadServer" action="POST"></fileupload>
                    </v-flex>
                    <v-flex xs12 v-if="fileUploadProgress != null">
                      <v-progress-linear
                          v-model="fileUploadProgress"
                          height="25"
                          style="text-align: center"
                      >
                        <strong>{{ Math.ceil(fileUploadProgress) }}%</strong>
                      </v-progress-linear>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-tab-item>
            <v-tab-item key="1" >
              <v-card-text>
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field label="Link Name" class="input-group--focused" required hint="Link Name is required" v-model="attachmentName" ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Link URL" class="input-group--focused" required hint="Link URL is required" v-model="uploadedFileURL" ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
          <v-card-actions>
            <v-btn class="green--text darken-1" :disabled="!(saveFileEnabled || saveLinkEnabled)" flat="flat" @click.native="saveFile">Confirm</v-btn>
            <v-btn class="orange--text darken-1" flat="flat" @click.native="cancelAddFile">Cancel</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </v-layout>
      <confirm-dialog :dialog="dialog" :dialogTitle="dialogTitle" :dialogText="dialogText" @onConfirm="confirmRemoveFile" @onCancel="onCancel" ></confirm-dialog>
  </v-container>
</template>
<script>
/* global Store */
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import FileUpload from '@/components/FileUpload.vue'
import moment from 'moment'
import axios from "axios";
import TypeAhead from "@/components/TypeAhead";
  export default {
    components: {
      ConfirmDialog,
      fileupload: FileUpload,
      TypeAhead
    },
    data () {
      return {
        addDocumentDialog: false,
        config: {
          key: 're1H1qB3C1A5C7C5F5hxxzkA-13B-11A2soycA5A4D4D3E4C2G2E3C1A2==',
          heightMin: 300,
          events: {
            'froalaEditor.initialized': function () {
              console.log('initialized')
            }
          }
        },
        fileUploadProgress: null,
        addAttachType:0,
        date: new Date().toISOString().substr(0, 10),
        modalDate: false,
        categoryId: null,
        modalTitle: 'Add Attachment',
        modalText: 'Enter a name for the file and select the file to upload',
        fileName: null,
        attachmentName: null,
        uploadedFileURL: null,
        saveFileEnabled: false,
        selectedFile: null,
        attachedFiles: [],
        addFileModal: false,
        fileToDelete: null,
        dialog: false,
        dialogTitle: "Delete Attachment",
        dialogText: "Do you want to delete this attachment?",
        errors: [],
        title: '',
        snackbarStatus: false,
        timeout: 3000,
        color: '',
        document: {
          body: ''
        },
        schoolLawTypes: [{title: "Statutes", id: 'S'}, {title: "Election Manual", id: 'M'}, {title: "Law Bulletin", id: 'N'}],
        revisionTypes: [{title: "Law Bulletin", id: 'L'}, {title: "Election Rule", id: 'R'}],
        policyTypes: [{title: "Mandatory", id: 'M'}, {title: "Legislative", id: 'L'}, {title: "Recommended", id: 'R'}],
        publicationTypes: ["Leader", "Journal", "Weekly Advocate", "MSBA Advocate"],
        resourceTypes: ["Form", "Resolution", "Model Agreement", "Informational Resource", "Sample Document"],
        dropzoneOptions: {
          url: 'https://httpbin.org/post',
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          headers: { "My-Awesome-Header": "header value" }
        }
      }
    },
    computed: {
      availableSubcats(){
        console.log('testing', this.document.webcat, this.$resourceLibrary.schema.categories)
        if(this.document.webcat != null) {
          let toReturn = this.$resourceLibrary.schema.categories.find(obj => {
            return obj.id === this.document.webcat
          })

          console.log('returning sub cats', toReturn.subCategories)

          return toReturn.subCategories
        } else {
          return []
        }

      },
      fileUploadServer() {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
          return "http://localhost:5000/upload"
        } else {
          return "https://search.mnmsba.org/api/upload"
        }
      },
      saveLinkEnabled() {
        if(this.addAttachType == 0)
          return false;

        var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
        var regexp = new RegExp(expression);
        let validURL = regexp.test(this.uploadedFileURL);

        console.log(this.uploadedFileURL, validURL)

        return (this.addAttachType == 1 && !(this.attachmentName == null || this.attachmentName.trim().length < 3) && validURL)
      },
      saveEnabled() {
        let document = this.document
          console.log('save enabled', document, this.attachedFiles)
        if (document.docType === 'policy') {
          return (document.title.length > 2 && document.purpose.length > 2 &&  document.num.length > 2 &&  document.series.length > 2 &&  document.type.length > 0)
        } else if (document.docType === 'school law' || document.docType === 'servicemanual') {
          return (document.description.length > 2 &&  document.keywords.length > 2 &&  document.revisorurl.length > 2 &&  document.citation.length > 2 && /* document.section.length > 2 &&*/  document.revnumber.length > 2 &&  document.revtype.length > 0)
        } else if (document.docType === 'publication' || document.docType === 'resource') {
          return (document.title.length > 2 &&   document.keywords.length > 2 )
        } else if (document.docType === 'leaderarchive') {
          return (document.publicationDate != null && this.attachedFiles.length > 0)
        } else if (document.docType === 'journalarchive') {
          return (document.publicationDate != null)
        }  else if (document.docType === 'weeklyadvocatearchive') {
          return (document.publicationDate != null && document.linkText.length > 5 && document.linkURL.length > 5)
        }   else if (document.docType === 'eclippingsarchive') {
          return (document.publicationDate != null && document.linkText.length > 5 && document.linkURL.length > 5 && document.sourceName.length > 3)
        }else {
          return true
        }

      }
    },
    methods: {
      getFeaturedArticles(articles){
        let toReturn = []
        articles.forEach((article)=>{
          let articleDoc = this.$getDocument(article)
          console.log('in getFeaturedArticles', articleDoc)
          if(articleDoc != null) {
            toReturn.push(articleDoc)
          }
        })
        return toReturn
      },
      formatDate (date) {
        return date ? moment(date).format('MM/DD/YYYY') : ''
      },
      startUpload(e) {
        // file upload start event
        this.fileUploadProgress = 0
        console.log('START UPLOAD', e);
      },
      errorUpload(e) {
        console.log('upload error', e)
      },
      finishUpload(e) {
        // file upload finish event
        console.log('current response', e)
        if(e.currentTarget.status != 200 && e.currentTarget.status != 201) {
          alert('Upload error code: ' + e.currentTarget.status)
          this.fileUploadProgress = 0
          return;
        }

        var uploadResult = JSON.parse(e.currentTarget.response)
        this.uploadedFileURL = this.fileUploadServer.replace('upload', 'download/') + uploadResult.filename + '-download-' + uploadResult.originalname
        console.log(e.currentTarget.response)
        console.log('download url for file is', this.uploadedFileURL);
        this.saveFileEnabled = true;
      },
      progress(e) {
        // file upload progress
        // returns false if progress is not computable
        //console.log(e.currentTarget.response)
        console.log('PROGESS', e);
        this.fileUploadProgress = e
      },
      cancel () {
        this.$router.back()
      },
      confirmRemoveFile() {
        this.dialog = false;
        for (let i = this.attachedFiles.length - 1; i >= 0; --i) {
          if (this.attachedFiles[i] === this.fileToDelete) {
            this.attachedFiles.splice(i, 1);
          }
        }
        this.fileToDelete = null
      },
      removeFile (item) {
        this.dialog = true;
        this.fileToDelete = item

      },
      onCancel () {
        this.selectedFile = null;
        this.dialog = false;
      },
      addFile () {
        this.addFileModal = true
      },
      save() {
        this.document.files = JSON.stringify(this.attachedFiles)
        console.log('about to save', this.document)
        this.$saveDocument(this.document).then((result)=>{
          if(result !== true && typeof result === 'object' && result !== null && result.check == 'fail') {
            console.log('mismatch', result.mismatch)
            this.document[result.mismatch] = result.remoteDoc[result.mismatch]
            this.document.id = result.remoteDoc.id
          }
         // this.$router.go(-1)
        })
      },
      addFeaturedArticle(value) {
        console.log('linked doc', value)
        this.document.featuredArticles.push(value.id)
        this.addDocumentDialog = false
      },
      removeFeaturedArticle(article){

        console.log('in removeFeaturedArticle', article)
        let index = this.document.featuredArticles.indexOf(article);
        if (index !== -1) {
          this.document.featuredArticles.splice(index, 1);
        }
      },
      saveFile () {
        if (this.addAttachType == 0) {
          // Store.dispatch('orders/addProductToOrder', this.productId)
          var nameToUse = this.attachmentName
          if (this.attachmentName == null || this.attachmentName.trim().length < 3) {
            nameToUse = this.fileName
          }

          if (this.attachedFiles === null) {
            this.attachedFiles = []
          }
          this.attachedFiles.push({name: nameToUse, fileName: this.fileName, link: this.uploadedFileURL})
          console.log(this.attachedFiles)
          this.resetAfterFileSave()
        } else {
          if (this.attachmentName == null || this.attachmentName.trim().length < 3) {
            nameToUse = this.uploadedFileURL
            this.fileName = ''
          } else {
            nameToUse = this.attachmentName
          }
         /* console.log('what does axious say')
          axios.get(this.uploadedFileURL).then((result)=>{
            console.log(result)
            if(1==2){

            }
          }).catch((error)=>{
            console.dir(error)
          })*/
          this.attachedFiles.push({name: nameToUse, fileName: '', link: this.uploadedFileURL})
          console.log(this.attachedFiles)
          this.resetAfterFileSave()
        }


      },
      resetAfterFileSave(){
        this.fileName = null;
        this.uploadedFileURL = null;
        this.attachmentName = null;
        this.addFileModal = false
        this.saveFileEnabled = false;
        this.fileUploadProgress = null;
      },
      cancelAddFile () {
        this.addFileModal = false
        this.resetAfterFileSave()
      },
    },
    created () {
      console.log('this.$route.params', this.$route.params)
      if (this.$route.params.id) {
        this.document = this.$getDocument(this.$route.params.id)
          this.title += 'Edit ' + this.$prettyDocType(this.document.docType, this.document.ischarter)
          this.attachedFiles = JSON.parse(this.document.files)
          console.log('got the doc', this.document)

      } else if (this.$route.params.type) {
        console.log('getting new document for schema...', this.$route.params.type)

        let schemaToFetch = this.$route.params.type

        if(schemaToFetch.includes('policy')) {
          console.log('changing scema to policy')
          schemaToFetch = 'policy'
        }

        let template = JSON.parse(JSON.stringify(this.$schemas[schemaToFetch]));
        template.docType = schemaToFetch

        if(this.$route.params.type == 'charterpolicy') {
          template.ischarter = 1
        }

        console.log('got template', template)
        this.document = template
        this.title += 'New '  + this.$prettyDocType(this.document.docType, this.document.ischarter)
        this.attachedFiles = []
      }
    },
    mounted () {
      if (this.$route.params.id) {
        // this.title = 'Edit Document'
      } else {
        // this.title = 'New ' + this.$route.params.type
      }

      var vueThis = this
      document.getElementsByName('fileUpload')[0].onchange = function () {
        console.log( this.files.item(0).name)
        vueThis.fileName = this.files.item(0).name
      }
    }
  }
</script>
<style>
  .ql-container{
    min-height: inherit;
    background: white;
  }
</style>
